// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import cookie       from 'js-cookie';

export default class CategoryCookie extends WebComponent {
  didMount() {
    const category = this.element.querySelector('input:checked').value;
    cookie.set('REALIZATION_CATEGORY', category);
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/CategoryCookie.js